import React from 'react';
import { ChainIcon } from './ChainIcon';
import './ConfirmMaxModal.css';

export const NetworkSwitchModal = ({
  isOpen,
  onClose,
  onConfirm,
  currentNetworkName,
  targetChain,
  isLoading,
}) => {
  if (!isOpen || !targetChain) return null;

  const currentNetwork = currentNetworkName || 'your current network';
  const targetNetwork = targetChain.networkLabel || targetChain.name || 'the selected network';

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        role="dialog"
        aria-modal="true"
        aria-labelledby="network-switch-title"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2 className="modal-title" id="network-switch-title">
            SWITCH NETWORKS?
          </h2>
          <button className="modal-close-btn" onClick={onClose} aria-label="Close modal">
            ×
          </button>
        </div>
        <div className="modal-body">
          <p className="modal-warning">
            Your wallet is connected to <strong>{currentNetwork}</strong>, but this swap is set to{' '}
            <strong>{targetNetwork}</strong>.
          </p>
          <p className="modal-description">
            Would you like to ask your connected wallet to switch networks?
          </p>
        </div>
        <div className="modal-footer">
          <button className="modal-btn modal-btn-cancel" onClick={onClose}>
            Not now
          </button>
          <button className="modal-btn modal-btn-confirm" onClick={onConfirm} disabled={isLoading}>
            <span className="status-message-row">
              <ChainIcon chainKey={targetChain.key} size={14} />
              <span>{isLoading ? 'Switching...' : 'Switch network'}</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};
